import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Edit } from 'lucide-react';
import { userService } from '../services/userService';
import Table from '../components/ui/Table';
import { formatShortDate } from '../utils/formatters';

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const data = await userService.getAll();
        setUsers(data);
      } catch (error) {
        console.error('Error fetching users:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const columns = [
    {
      key: 'username',
      label: 'Логин',
      render: (value) => <span className="font-medium">{value}</span>,
    },
    {
      key: 'first_name',
      label: 'Имя',
      render: (value, row) => `${value || ''} ${row.last_name || ''}`.trim() || '-',
    },
    {
      key: 'email',
      label: 'Email',
    },
    {
      key: 'created_at',
      label: 'Дата регистрации',
      render: (value) => formatShortDate(value),
    },
  ];

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Зарегистрированные пользователи</h1>
        <p className="mt-1 text-sm text-gray-500">
          Всего: {loading ? '...' : users.length}
        </p>
      </div>

      <Table
        columns={columns}
        data={users}
        loading={loading}
        actions={(row) => (
          <Link
            to={`/admin/users/${row.id}/edit`}
            className="text-primary-600 hover:text-primary-800"
            title="Редактировать"
          >
            <Edit className="h-5 w-5" />
          </Link>
        )}
      />
    </div>
  );
}
